export var validateAadhaarInput = (formData, isChecked) => {
  var _formData$value = formData.value,
    value = _formData$value === void 0 ? '' : _formData$value,
    fieldState = formData.state,
    showLoader = formData.showLoader,
    validationRegex = formData.validationRegex;
  var isError = fieldState === 'error';
  var isLoading = showLoader === true;
  if (typeof validationRegex === 'string') {
    var isValid = new RegExp(validationRegex).test(value);
    return isValid && !isError && !isLoading && isChecked;
  }
  return !isError && !isLoading;
};
export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};
export var getSubHeading = (subHeading, value) => {
  if (subHeading) {
    return subHeading;
  }
  return (value === null || value === void 0 ? void 0 : value.length) === 12 || (value === null || value === void 0 ? void 0 : value.length) === 16 ? "" + (value.slice(0, 4) + 'X'.repeat(value.length - 6) + value.slice(-2)) : '';
};